<template>
  <span class="d-activity-author">
    <span
      v-if="!!activity.is_owner"
      title="You"
    >
      You
    </span>
    <DUserLinkPopup
      v-else
      :user-id="activity.user.id"
    >
      <template slot="content">
        <a
          class="resource-link"
          :href="activity.user.url"
          target="_blank"
        >{{ activity.user.firstname }} {{ activity.user.lastname }}</a>
      </template>
    </DUserLinkPopup>
  </span>
</template>

<script>
import DUserLinkPopup from '@d-components/d-user-link-popup/d-user-link-popup.vue';

export default {
  components: {
    DUserLinkPopup,
  },
  props: {
    activity: {
      type: Object,
      required: true,
    },
  },
};
</script>

<style lang="scss" scoped>
.d-activity-author {
  align-items: center;
}
</style>
